module.exports = __webpack_public_path__ + "img/profile.49fdd9be.svg";